import cn from 'classnames';
import React, { useCallback } from 'react';

import type { FiveSymbolLocale } from '#common/types/locale';

import { analyticsManager } from '../../../../scripts/afterBlocks/analytics/analytics';
import { AnalyticsActions } from '../../../../scripts/afterBlocks/analytics/analyticsActions';
import { AnalyticsCategories } from '../../../../scripts/afterBlocks/analytics/analyticsCategories';
import { UniversalCart } from '../../../../scripts/blocks/store/cart/UniversalCart';
import { toggleCartEmail } from '../../../../scripts/blocks/store/cartEmail';
import { openModalWindow } from '../../../../scripts/ui-components/editor/modalWindow';
import { getStoreCheckoutText } from '../../../../utils/translation';

export const goToCheckoutClick = ({
  cart,
  sku,
  section,
  closeBundleInfoModal,
}: {
  cart: UniversalCart;
  sku: string;
  section?: 'pop-up';
  closeBundleInfoModal?: (sku: string) => void;
}) => {
  const cartModal = document.querySelector('[data-cart-modal]');
  toggleCartEmail(cartModal, cart);
  openModalWindow(cartModal, 'Cart');
  closeBundleInfoModal?.(sku);

  analyticsManager.sendEvent({
    category: AnalyticsCategories.STORE,
    event: AnalyticsActions.OPEN_CART,
    page: `landing_${AnalyticsActions.OPEN_CART}`,
  });
  analyticsManager.sendEvent({
    category: AnalyticsCategories.STORE,
    event: AnalyticsActions.CLICK_CHECKOUT,
    page: `landing_store_${AnalyticsActions.CLICK_CHECKOUT}`,
    section,
  });
};

export interface IGoToCheckoutButtonProps {
  sku: string;
  cart: UniversalCart;
  locale: FiveSymbolLocale;
  hidden?: boolean;
  buttonClassPrefix?: string;
  section?: 'pop-up';
  closeBundleInfoModal?: (sku: string) => void;
}

const GoToCheckoutButton: React.FC<IGoToCheckoutButtonProps> = ({
  sku,
  cart,
  locale,
  hidden,
  buttonClassPrefix,
  section,
  closeBundleInfoModal,
}: IGoToCheckoutButtonProps) => {
  const handleClick = useCallback(() => {
    goToCheckoutClick({ cart, sku, section, closeBundleInfoModal });
  }, [cart]);

  return (
    <button
      className={cn('store__buy-btn', {
        [`${buttonClassPrefix}__go-to-checkout`]: buttonClassPrefix,
      })}
      data-button-type='cart-modal-opener'
      data-sku={sku}
      onClick={handleClick}
      hidden={hidden}
    >
      <span className='store__buy-btn-text'>
        {getStoreCheckoutText(locale)}
      </span>
    </button>
  );
};

export default GoToCheckoutButton;
